import { clone } from 'reducers/helper.js';
import _ from 'lodash';

let orderOfMeetingRoomsListing = (mA, mB) => {
  if (mA.participants.length < mB.participants.length) {
    return 1; //B goes first
  } else if (mA.participants.length > mB.participants.length) {
    return -1; //A goes first
  } else if (mA.name > mB.name) {
    return 1; //B goes first
  } else if (mB.name > mA.name) {
    return -1; //A goes first
  } else if (mA.parentGroupName > mB.parentGroupName) {
    return 1; //B goes first
  } else if (mB.parentGroupName > mA.parentGroupName) {
    return -1; //A Goes First
  } else if (mA.organisationAbbreviatedName > mB.organisationAbbreviatedName) {
    return 1; //B goes first
  } else if (mB.organisationAbbreviatedName > mA.organisationAbbreviatedName) {
    return -1; //A goes first
  } else {
    return 0; //do nothing
  }
};

export const sortMeetingRooms = (meetingRooms) => {
  return clone(meetingRooms).sort(orderOfMeetingRoomsListing);
};

export const sortOrganisationalUnit = (organisations) => {
  return clone(organisations).sort(orderOfOrganisationalUnitsListing);
};

let orderOfOrganisationalUnitsListing = (orgA, orgB) => {
  if (orgA.name > orgB.name) {
    return 1; //B goes first
  } else if (orgB.name > orgA.name) {
    return -1; //A goes first
  } else {
    return 0; //do nothing
  }
};

export const sortUsersIcanManage = (users) => {
  return users.sort((userA, userB) => {
    // active member goes before email only user
    if (!userA.isEmailOnlyUser && userB.isEmailOnlyUser) return -1; // userA goes first
    if (userA.isEmailOnlyUser && !userB.isEmailOnlyUser) return 1; // userB goes first

    // sorting for active members
    if (!userA.isEmailOnlyUser && !userB.isEmailOnlyUser) {
      let userAFirstName = userA.firstName ? userA.firstName.toLowerCase() : userA;
      let userBFirstName = userB.firstName ? userB.firstName.toLowerCase() : userB;
      let userALastName = userA.lastName ? userA.lastName.toLowerCase() : userA;
      let userBLastName = userB.lastName ? userB.lastName.toLowerCase() : userB;
      if (userAFirstName < userBFirstName) return -1; // userA goes first
      if (userAFirstName > userBFirstName) return 1; // userB goes first
      if (userALastName < userBLastName) return -1; // userA goes first
      if (userALastName > userBLastName) return 1; // userB goes first
    }

    // sorting for email only members
    if (userA.isEmailOnlyUser && userB.isEmailOnlyUser) {
      if (userA.email.toLowerCase() < userB.email.toLowerCase()) return -1; // userA goes first
      if (userA.email.toLowerCase() > userB.email.toLowerCase()) return 1; // userB goes first
    }

    // both users are same
    return 0;
  });
};

export const sortManageRoleNaming = (roleNames) => {
  return clone(roleNames).sort((roleNameA, roleNameB) => {
    return roleNameA.sortOrder - roleNameB.sortOrder;
  });
};

export const sortAssignedTags = (tags) => {
  tags.forEach(
    (tag) =>
      (tag.tagValues = tag.tagValues.sort((valueA, valueB) => {
        if (valueA.tagValue < valueB.tagValue) return -1; // valueA goes first
        if (valueA.tagValue > valueB.tagValue) return 1; // valueB goes first
        return 0; // tag values must be equal
      }))
  );
  return tags.sort((tagA, tagB) => {
    if (tagA.tagName < tagB.tagName) return -1; // tagA goes first
    if (tagA.tagName > tagB.tagName) return 1; // tagB goes first
    return 0; // tag values must be equal
  });
};

// Sorting the tag values according to alphabetical order
export const sortTagValues = (tagValue) => {
  return tagValue.sort((tagValueA, tagValueB) => {
    if (tagValueA.tagValue < tagValueB.tagValue) {
      return -1;
    }
    if (tagValueA.tagValue > tagValueB.tagValue) {
      return 1;
    }
    return 0;
  });
};

export const sortMyRoles = (myRoles) => {
  const orgType = 'Organisational Unit';
  const waType = 'Waiting Area';
  const grpType = 'Group';
  let sortOrderRoles = _.orderBy(
    myRoles,
    [
      (myRole) => myRole.name.toLowerCase(),
      (myRole) => myRole.organisationAbbreviatedName,
      (myRole) => myRole.role.toLowerCase(),
    ],
    ['asc']
  );

  return sortOrderRoles.sort((roleA, roleB) => {
    if (roleA.type == orgType && roleB.type != orgType) {
      return -1; //retur B
    } else if (roleA.type != orgType && roleB.type == orgType) {
      return 1; //retur B
    } else if (roleA.type == waType && roleB.type != waType) {
      return -1;
    } else if (roleA.type != waType && roleB.type == waType) {
      return 1;
    } else if (roleA.type != grpType && roleB.type == grpType) {
      return 1; //retur A
    }
    return 0;
  });
};

export const sortInvitedRoles = (invitedRoles) => {
  const orgType = 'Organisational Unit';
  const waType = 'Waiting Area';
  const grpType = 'Group';
  let sortOrderRoles = _.orderBy(
    invitedRoles,
    [(invitedRoles) => invitedRoles.networkName.toLowerCase(), (invitedRoles) => invitedRoles.roleName.toLowerCase()],
    ['asc']
  );

  return sortOrderRoles.sort((roleA, roleB) => {
    if (roleA.networkTypeName == orgType && roleB.networkTypeName != orgType) {
      return -1; //retur B
    } else if (roleA.networkTypeName != orgType && roleB.networkTypeName == orgType) {
      return 1; //retur B
    } else if (roleA.networkTypeName == waType && roleB.networkTypeName != waType) {
      return -1;
    } else if (roleA.networkTypeName != waType && roleB.networkTypeName == waType) {
      return 1;
    } else if (roleA.networkTypeName != grpType && roleB.networkTypeName == grpType) {
      return 1; //retur A
    }
    return 0;
  });
};
